import React, { useContext } from 'react';

import FileBuffer from './FileBuffer';

interface IFileBufferContext {
  fileBuffer?: FileBuffer;
}

export const FileBufferContext = React.createContext<Partial<IFileBufferContext>>({});

export const useFileBufferContext = () => useContext(FileBufferContext);
